export function jsonReferrerIDs(config, data) {
  if (typeof config !== 'object' || !data || !config) {
    return;
  }

  Object.keys(config).forEach((key) => {
    if (data[key] && data[key].id) {
      config[key].id = data[key].id;
    }

    jsonReferrerIDs(config[key], data[key]);
  });
}

export default {
  jsonReferrerIDs,
};
